import { render, staticRenderFns } from "./trans-service-info.html?vue&type=template&id=3837473a&scoped=true&external"
import script from "./trans-service-info.js?vue&type=script&lang=js&external"
export * from "./trans-service-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-service-info.scss?vue&type=style&index=0&id=3837473a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837473a",
  null
  
)

export default component.exports